import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import TODOIcon from "./../../media/message-add.svg";
import deleteButtonIcon from "./../../media/delete-button.svg";
import MessageAddIcon from "./../../media/message-add-black.svg";
import MessageOkayIcon from "./../../media/message-okay-black.svg";
import ThreeDropsIcon from "./../../media/three-drops-black.svg";
import MessageAddIconOrange from "./../../media/message-add-orange.svg";
import MessageOkayIconOrange from "./../../media/message-okay-orange.svg";
import ThreeDropsIconOrange from "./../../media/three-drops-orange.svg";
import MyTODO from "./myTODO.js"; // Importujemy nowy komponent
import ManagerTODO from "./managerTODO.js";
import ForTODO from "./forTODO.js";
import "../../styleSheet/main/components/TODO/myTODO/myTODO.css";
import "../../styleSheet/main/components/TODO/managerTODO/managerTODO.css";
import "../../styleSheet/main/components/TODO/forTODO/forTODO.css";

const TODO = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedIcon, setSelectedIcon] = useState("add"); // Domyślnie pierwszy icon-item
  const [hoveredIcon, setHoveredIcon] = useState(null);
  const todoRef = useRef(null);

  const toggleChat = () => {
    setIsOpen((prevState) => !prevState);
  };

  const { t } = useTranslation();

  const handleIconClick = (iconName) => {
    setSelectedIcon(iconName);
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  // Dodaj/usuń klasę do body gdy TODO jest otwarte (dla mobilnych)
  useEffect(() => {
    const checkMobileAndToggleClass = () => {
      if (isOpen && window.innerWidth <= 768) {
        document.body.classList.add("todo-mobile-open");
      } else {
        document.body.classList.remove("todo-mobile-open");
      }
    };

    // Wywołaj od razu
    checkMobileAndToggleClass();

    // Dodaj listener na resize
    window.addEventListener("resize", checkMobileAndToggleClass);

    // Cleanup
    return () => {
      document.body.classList.remove("todo-mobile-open");
      window.removeEventListener("resize", checkMobileAndToggleClass);
    };
  }, [isOpen]);

  // Dodaj obsługę kliknięć poza komponentem TODO
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (todoRef.current && !todoRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    // Dodaj event listener tylko gdy TODO jest otwarte
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    // Cleanup - usuń event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="todo-container" ref={todoRef}>
      <div className="todo-icon" onClick={toggleChat}>
        <img src={TODOIcon} alt={t("todo.title")} />
        <span className="todo-text">{t("todo.title")}</span>
      </div>
      {isOpen && (
        <div className="todo-chat">
          <div className="close" onClick={handleCancel}>
            <img className="close-button" src={deleteButtonIcon} alt="Close" />
          </div>

          <div className="todo-main-content">
            {/* Wyświetlaj MyTODO tylko jeśli 'add' jest zaznaczone */}
            {selectedIcon === "add" && (
              <MyTODO
                selectedIcon={selectedIcon}
                handleIconClick={handleIconClick}
                hoveredIcon={hoveredIcon}
                setHoveredIcon={setHoveredIcon}
              />
            )}

            {/* Wyświetlaj ManagerTODO tylko jeśli 'okay' jest zaznaczone */}
            {selectedIcon === "okay" && <ManagerTODO />}

            {selectedIcon === "drops" && <ForTODO />}
          </div>

          <div className="icons-section">
            <div
              className="icon-item"
              onMouseEnter={() => setHoveredIcon("add")}
              onMouseLeave={() => setHoveredIcon(null)}
              onClick={() => handleIconClick("add")}
              onTouchStart={() => setHoveredIcon("add")} // Dla mobilnych
              onTouchEnd={() => setHoveredIcon(null)} // Dla mobilnych
              style={{ touchAction: "manipulation" }} // Optymalizacja dla dotyku
            >
              <img
                src={
                  selectedIcon === "add" ? MessageAddIconOrange : MessageAddIcon
                }
                alt={t("todo.yours")}
                style={{ pointerEvents: "none" }}
              />
              <span
                style={{
                  color: selectedIcon === "add" ? "#FF9900" : "black",
                  pointerEvents: "none",
                }}
              >
                {t("todo.yours")}
              </span>
            </div>
            <div
              className="icon-item"
              onMouseEnter={() => setHoveredIcon("okay")}
              onMouseLeave={() => setHoveredIcon(null)}
              onClick={() => handleIconClick("okay")}
              onTouchStart={() => setHoveredIcon("okay")} // Dla mobilnych
              onTouchEnd={() => setHoveredIcon(null)} // Dla mobilnych
              style={{ touchAction: "manipulation" }} // Optymalizacja dla dotyku
            >
              <img
                src={
                  selectedIcon === "okay"
                    ? MessageOkayIconOrange
                    : MessageOkayIcon
                }
                alt={t("todo.manager")}
                style={{ pointerEvents: "none" }}
              />
              <span
                style={{
                  color: selectedIcon === "okay" ? "#FF9900" : "black",
                  pointerEvents: "none",
                }}
              >
                {t("todo.manager")}
              </span>
            </div>
            <div
              className="icon-item"
              onMouseEnter={() => setHoveredIcon("drops")}
              onMouseLeave={() => setHoveredIcon(null)}
              onClick={() => handleIconClick("drops")}
              onTouchStart={() => setHoveredIcon("drops")} // Dla mobilnych
              onTouchEnd={() => setHoveredIcon(null)} // Dla mobilnych
              style={{ touchAction: "manipulation" }} // Optymalizacja dla dotyku
            >
              <img
                src={
                  selectedIcon === "drops"
                    ? ThreeDropsIconOrange
                    : ThreeDropsIcon
                }
                alt={t("todo.for")}
                style={{ pointerEvents: "none" }}
              />
              <span
                style={{
                  color: selectedIcon === "drops" ? "#FF9900" : "black",
                  pointerEvents: "none",
                }}
              >
                {t("todo.for")}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TODO;
